const en_wyrmprints = {
  400001: 'Ring of Exaltation',
  400002: 'Seafood Soup',
  400003: 'Dragon Arcanum',
  400004: 'Mana Fount',
  400005: 'Old Harp',
  400006: 'Scorn the Destrier',
  400007: 'Halo',
  400008: 'Teatime',
  400009: 'Bellathorna',
  400010: 'Alberian Banner',
  400011: 'Cry of the Horn',
  400012: 'Howling Predator',
  400013: 'Syndicate Mask',
  400014: 'Hallowed Mountains',
  400015: 'Lakeside Euphony',
  400016: 'Dragon\'s Nest',
  400017: 'Enchiridion',
  400018: 'Ironside Shield',
  400019: 'Winds of Saint Lotier',
  400020: 'Aromatherapy',
  400021: 'Eight-Leaf Clover',
  400022: 'Forbidden Relic',
  400023: 'Unfulfilled Visions',
  400024: 'Liber Grimortis',
  400025: 'Night Harbinger',
  400026: 'Tracks of Hope',
  400027: 'Vio Rhyse Alberia!',
  400028: 'Potiongrass',
  400029: 'Crown of Yore',
  400030: '',
  400031: 'Nevermelt Ice',
  400032: 'Pumpkin Pail',
  400033: 'Flower in the Fray',
  400034: 'Destiny\'s Hand',
  400035: 'Sniper\'s Allure',
  400036: 'Promises in the Rain',
  400037: 'Fireside Gathering',
  400038: 'Trove of Knowledge',
  400039: 'Castaway\'s Journal',
  400040: 'Lord of the Skies',
  400041: 'King\'s Countenance',
  400042: 'Braving the Unknown',
  400043: 'What a Handful!',
  400044: 'How to Flee Properly',
  400045: 'One with the Shadows',
  400046: 'Warlust',
  400047: 'Armorer\'s Aspirations',
  400048: 'Revolutionary Magic',
  400049: 'Sisters of the Anvil',
  400050: 'Dueling Dancers',
  400051: 'Together We Stand',
  400052: 'Give Me Your Wounded',
  400053: 'Paladyn Defender',
  400054: 'Pipe Down',
  400055: 'Greatwyrm Midgardsormr',
  400056: 'Greatwyrm Mercury',
  400057: 'Greatwyrm Brunhilda',
  400058: 'Greatwyrm Jupiter',
  400059: 'Greatwyrm Zodiark',
  400060: 'The Warrioresses',
  400061: 'Silke Lends a Hand',
  400062: 'Valiant Crown',
  400063: 'Flash of Genius',
  400064: 'Evening of Luxury',
  400065: 'Worthy Rivals',
  400066: 'Auspex\'s Prayer',
  400067: 'Dragon Brethren',
  400068: 'Luca\'s Prank',
  400069: 'Happier Times',
  400070: 'Levin\'s Champion',
  400071: 'Nightstalker',
  400072: 'Glorious Tempest',
  400073: 'United by One Vision',
  400074: 'Cleo\'s Ruse',
  400075: 'Tough Love',
  400076: 'Crystalian Envoy',
  400077: 'Witch\'s Kitchen',
  400078: 'Of Tricks and Treats',
  400079: '',
  400080: 'Warrior Maiden',
  400081: '',
  400082: '',
  400083: 'After an Eternity',
  400084: 'An Ancient Oath',
  400085: 'Beauty\'s Secret',
  400086: '',
  400087: 'Plunder Pals',
  400088: '',
  400089: '',
  400090: 'Slow and Steady',
  400091: 'A Wish Upon the Yuletree',
  400092: 'The Chocolatiers',
  400093: 'New World Escort',
  400094: '',
  400095: 'To The Extreme!',
  400096: 'The Bridal Dragon',
  400097: 'Twinfold Bonds',
  400098: 'Summer Paladyns',
  400099: 'Jewels of the Sun',
  400100: 'Samurai Siesta',
  400101: 'The Halidom\'s Picnic',
  400102: 'Better Together',
  400103: 'Gentle Winds',
  400104: 'Gale of Beauty',
  400105: 'Fresh Perspective',
  400106: 'Garuda\'s Feathers',
  400107: 'Louise\'s Hobbies',
  400108: 'Queen of the Blue Seas',
  400109: '',
  400110: 'Resounding Rendition',
  400111: 'Heavenly Holiday',
  400112: 'Kicking Back',
  400113: 'Secret Friend',
  400114: 'As the Snow Falls',
  400115: 'The Prince of Dragonyule',
  400116: 'Saintly Delivery',
  400117: 'Roast Feast',
  400118: 'A Slice of Dragonyule',
  400119: 'First-Rate Hospitality',
  400120: '',
  400121: 'Volcanic Queen',
  400122: '',
  400123: 'The Greatest Gift',
  400124: 'Happy New Year',
  400125: 'Heralds of Hinomoto',
  400126: 'Hanetsuki Rally',
  400127: 'Luck of the Draw',
  400128: 'Dragon and Tamer',
  400129: 'Stellar Show',
  400130: 'Welcome One and All',
  400131: 'Astounding Trick',
  400132: '',
  400133: '',
  400134: '',
  400135: 'Candy Couriers',
  400136: 'Lunar Festivities',
  400137: 'Blossoms Ablaze',
  400138: 'Dragon Dance',
  400139: 'The Rose Prince',
  400140: 'Entwined Flames',
  400141: 'To My Beloved',
  400142: 'The Petal Queen',
  400143: 'A Heartfelt Gift',
  400144: 'Valentine\'s Venture',
  400145: 'An Indelible Date',
  400146: 'Elegant Escort',
  400147: 'Take My Hand',
  400148: 'Honest Repose',
  400149: '',
  400150: 'A Solitary Light',
  400151: 'The Davian Wetlands',
  400152: 'Delightful Dancer',
  400153: 'Partners in Truth',
  400154: 'The Fleeting Girl',
  400155: '',
  400156: 'The Heretic\'s Laboratory',
  400157: 'Hitting the Books',
  400158: 'King of the Skies',
  400159: '',
  400160: '',
  400161: '',
  400162: '',
  400163: 'Kung Fu Masters',
  400164: '',
  400165: '',
  400166: '',
  400167: 'The Shining Overlord',
  400168: 'Study Rabbits',
  400169: '',
  400170: '',
  400171: 'A Maddened Master',
  400172: 'Forest Bonds',
  400173: '',
  400174: 'Egg-Shaped Dreams',
  400175: 'Tiny Dragoñatas',
  400176: 'A Mother\'s Love',
  400177: '',
  400178: '',
  400179: '',
  400180: '',
  400181: '',
  400182: '',
  400183: '',
  400184: '',
  400185: '',
  400186: '',
  400187: '',
  400188: '',
  400189: '',
  400190: '',
  400191: '',
  400192: '',
  400193: '',
  400194: '',
  400195: '',
  400196: '',
  400197: '',
  400198: '',
  400199: '',
  400200: '',
  400201: '',
  400202: '',
  400203: '',
  400204: '',
  400205: '',
  400206: '',
  400207: '',
  400208: '',
  400209: '',
  400210: '',
  400211: '',
  400212: '',
  400213: '',
  400214: '',
  400215: '',
  400216: '',
  400217: '',
  400218: '',
  400219: '',
  400220: '',
  400221: '',
  400222: '',
  400223: '',
  400224: '',
  400225: '',
  400226: '',
  400227: '',
  400228: '',
  400229: '',
  400230: '',
  400231: '',
  400232: '',
  400233: '',
  400234: '',
  400235: '',
  400236: '',
  400237: '',
  400238: '',
  400239: '',
  400240: '',
  400241: '',
  400242: '',
  400243: 'Sisters\' Day Out',
  400244: '',
  400245: 'The Dragon Smiths',
  400246: '',
  400247: '',
  400248: '',
  400249: '',
  400250: '',
  400251: '',
  400252: '',
  400253: '',
  400254: '',
  400255: '',
  400256: '',
  400257: '',
  400258: '',
  400259: '',
  400260: '',
  400261: '',
  400262: '',
  400263: '',
  400264: '',
  400265: '',
  400266: '',
  400267: '',
  400268: '',
  400269: '',
  400270: '',
  400271: '',
  400272: '',
  400273: '',
  400274: '',
  400275: '',
  400276: '',
  400277: 'The Heroes Arrive',
  400278: '',
  400279: 'The Order\'s Messenger Owl',
  400280: 'Bonds Between Worlds',
  400281: '',
  400282: 'Halidom Grooms',
  400283: '',
  400284: '',
  400285: 'Breakfast at Valerio\'s',
  400286: 'The Queen of the Knife',
  400287: '',
  400288: 'Berry Lovable Friends',
  400289: '',
  400290: '',
  400291: '',
  400292: '',
  400293: 'A Brief Repose',
  400294: '',
  400295: '',
  400296: '',
  400297: '',
  400298: '',
  400299: '',
  400300: '',
  400301: '',
  400302: '',
  400303: '',
  400304: '',
  400305: '',
  400306: '',
  400307: '',
  400308: '',
  400309: '',
  400310: '',
  400311: '',
  400312: '',
  400313: '',
  400314: '',
  400315: '',
  400316: '',
  400317: '',
  400318: '',
  400319: '',
  400320: '',
  400321: '',
  400322: '',
  400323: '',
  400324: '',
  400325: '',
  400326: '',
  400327: '',
  400328: '',
  400329: '',
  400330: '',
  400331: '',
  400332: '',
  400333: '',
  400334: 'Indelible Summer',
  400335: 'Taiko Tandem',
  400336: 'Beach Battle',
  400337: 'Preacher\'s Vacation',
  400338: 'Seaside Princess',
  400339: 'The Bustling Hut',
  400340: 'Surfing Siblings',
  400341: '',
  400342: '',
  400343: '',
  400344: '',
  400345: '',
  400346: '',
  400347: '',
  400348: '',
  400349: '',
  400350: '',
  400351: '',
  400352: '',
  400353: '',
  400354: '',
  400355: '',
  400356: '',
  400357: '',
  400358: '',
  400359: '',
  400360: '',
  400361: '',
  400362: '',
  400363: '',
  400364: '',
  400365: '',
  400366: '',
  400367: '',
  400368: '',
  400369: '',
  400370: '',
  400371: '',
  400372: '',
  400373: '',
  400374: '',
  400375: '',
  400376: '',
  400377: '',
  400378: '',
  400379: 'Hastened Squall',
  400380: 'Castle Cheer Corps',
  400381: 'Beautiful Nothingness',
  400382: 'Ruler of Darkness',
  400383: '',
  400384: 'Endless Waltz',
  400385: 'Odd Sparrows',
  400386: '',
  400387: 'The Bewitching Magician',
  400388: 'Masquerade Mission',
  400389: 'Prayers Unto Him',
  400390: 'From Whence He Comes',
  400391: 'Dear Diary',
  400392: 'Chariot Drift',
  400393: 'Spirit of the Season',
  400394: 'Glittering Dragonyule',
  400395: 'Howling to the Heavens',
  400396: 'Fluff Aplenty',
  400397: 'Mega Friends',
  400398: 'Wily Warriors: Bubble & Wood',
  400399: 'Wily Warriors: Air & Crash',
  400400: 'Wily Warriors: Metal & Quick',
  400401: 'Wily Warriors: Flash & Heat',
  400402: '',
  400403: '',
  400404: '',
  400405: '',
  400406: 'A Game of Cat and Boar',
  400407: 'The Wyrmclan Duo',
  400408: 'A New Year\'s Battle',
  400409: 'A Dog\'s Day',
  400410: 'The Plaguebringer',
  400411: 'In an Unending World',
  400412: 'Roll On',
  400413: 'The Fires of Hate',
  400414: 'The Maid Crusade',
  400415: 'Soaring Terror',
  400416: 'A Suit of Midnight',
  400417: 'Felyne Hospitality',
  400418: 'The Lurker in the Woods',
  400419: 'Unexpected Requests',
  400420: '',
  400421: '',
  400422: '',
  400423: '',
  400424: 'Primal Crisis',
  400425: '',
  400426: '',
  400427: '',
  400428: '',
  400429: '',
  400430: '',
  400431: 'Blossoms in a New Year\'s Sky'
}

export default en_wyrmprints